module.exports = "//d274d294w9cx2v.cloudfront.net/408176aba57af039ae12977aebbaa84ea7238bef/images/photo-couple.png";